import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { stringify } from 'querystring';
import React, { useContext, useMemo, useEffect } from 'react';
import mapValues from 'lodash/mapValues';
import { last } from 'lodash';
import { FeatureFlagsContext } from '../context';
import { FeatureFlagName } from '../feature-flags';
import { getClientConfigBool } from '../config';
import { RawCookieName } from '../constants';
import { isBrowser, isLocalStorageEnabled } from '../env';
import { useRemoteFeatureManagement } from '../hooks/use-remote-feature-management';
import { jsx as _jsx } from "react/jsx-runtime";
const flagValuesFromEnv = mapValues(FeatureFlagName, getClientConfigBool);
export default function FeatureFlagsProvider(_ref) {
  let {
    children,
    doGetFromEnv,
    overrides
  } = _ref;
  const remoteFeatures = useRemoteFeatureManagement();
  const higherContext = useContext(FeatureFlagsContext);
  const baseValues = doGetFromEnv ? flagValuesFromEnv : higherContext;
  return /*#__PURE__*/_jsx(FeatureFlagsContext.Provider, {
    value: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, baseValues), remoteFeatures === null || remoteFeatures === void 0 ? void 0 : remoteFeatures.flags), overrides), {}, {
      remote: remoteFeatures
    }),
    children: children
  });
}
const {
  FEATURE_FLAGS
} = RawCookieName;
export function useFeatureFlagOverridesFromQuery(queryParams) {
  var _localStorage$getItem;
  const storedFlags = isBrowser() && isLocalStorageEnabled() ? (_localStorage$getItem = localStorage.getItem(FEATURE_FLAGS)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : '' : '';
  const overrides = useMemo(() => {
    const normalizedQueryParams = new URLSearchParams(stringify(queryParams));
    const storedParams = new URLSearchParams(storedFlags);
    const allParams = new URLSearchParams();
    for (const [key, value] of storedParams) {
      allParams.set(key, value);
    }
    for (const [key, value] of normalizedQueryParams) {
      allParams.set(key, value);
    }
    return determineFlags(FeatureFlagName, allParams);
  }, [storedFlags, queryParams]);
  useEffect(() => {
    if (!isLocalStorageEnabled()) {
      return;
    }
    const updatedStoredParams = Object.entries(overrides).reduce((acc, current) => {
      acc.set(flagNameToQueryParamName(current[0]), current[1] ? 'enabled' : 'disabled');
      return acc;
    }, new URLSearchParams());
    const updatedStoredFlags = updatedStoredParams.toString();
    if (!updatedStoredFlags) {
      localStorage.removeItem(FEATURE_FLAGS);
    } else if (storedFlags !== updatedStoredFlags) {
      localStorage.setItem(FEATURE_FLAGS, updatedStoredFlags);
    }
  }, [storedFlags, overrides]);
  return overrides;
}
export function determineFlags(flagNames, queryParams) {
  if (flagNames) {
    const overrides = {};
    for (const flagName in flagNames) {
      const queryStringFlagName = flagNameToQueryParamName(flagName);
      const finalValue = last(queryParams.getAll(queryStringFlagName));
      if (finalValue === 'enabled') {
        overrides[flagName] = true;
      } else if (finalValue === 'disabled') {
        overrides[flagName] = false;
      }
    }
    return overrides;
  } else {
    return {};
  }
}
function flagNameToQueryParamName(flagName) {
  return flagName.replace('NEXT_PUBLIC_FEAT_FLAG_', '').toLowerCase().replace(/_/g, '-');
}